import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {filter, mergeMap, map, withLatestFrom} from 'rxjs/operators';
import {UuidService} from '@orga-app/providers/uuid.service';
import {INCIDENT_SPEICHERN, IncidentSpeichernAction, LADE_AKTUELLE_VERANSTALTUNGEN, LadeAktuelleVeranstaltungenAction, PAGE_STATE_RESET, PageStateResetAction, SETZE_INCIDENT_DETAIL_ID, SetzeIncidentDetailIdAction} from './incident.actions.ui';
import {getIncidentDetail, getSelectedIncidentId} from './incident.selectors';
import {GetIncidentDetailAction, GetVeranstaltungenAction, PostIncidentAnlegen2Action, PostIncidentTitelUndBeschreibungSetzenAction} from '../../../client-ngrx/incidents';
import {IncidentAnlegen2Request, IncidentBeschreibungRequest, IncidentDetail} from '../../../clients/incidents';
import {NotificationService} from '@orga-app/providers/notification.service';
import {Observable} from 'rxjs';

@Injectable()
export class IncidentPageUiEffects {

    pageNeuLaden$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<PageStateResetAction>(PAGE_STATE_RESET),
        withLatestFrom(this.store$.pipe(select(getSelectedIncidentId))),
        filter(([, incidentId]) => incidentId !== null && incidentId !== ''),
        mergeMap(([, incidentId]) =>
            [
                new GetIncidentDetailAction(incidentId),
                new GetVeranstaltungenAction(true, false)
            ]
        )
    ));

    ladeAktuelleVeranstaltungen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<LadeAktuelleVeranstaltungenAction>(LADE_AKTUELLE_VERANSTALTUNGEN),
        mergeMap(() =>
            [
                new GetVeranstaltungenAction(true, false)
            ]
        )
    ));

    datenLaden$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<SetzeIncidentDetailIdAction>(SETZE_INCIDENT_DETAIL_ID),
        filter((x) => x.payload !== null && x.payload !== ''),
        mergeMap((x) =>
            [
                new GetIncidentDetailAction(x.payload)
            ]
        )
    ));

    incidentSpeichern$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<IncidentSpeichernAction>(INCIDENT_SPEICHERN),
        withLatestFrom(this.store$.pipe(select(getIncidentDetail))),
        filter(([, detail]) => {
            if (detail.titel === null || detail.titel === '') {
                this.notificationService.showMessageWithOk('Bitte einen Titel angeben. Sonst kann der Incident nicht gespeichert werden.');
                return false;
            }
            return true;
        }),
        map(([, detail]: [IncidentSpeichernAction, IncidentDetail]) => {
            let incidentId = detail.incident_id;
            if (incidentId === undefined || incidentId === null) {
                // Neu
                incidentId = this.uuid.generateUUID();

                const request: IncidentAnlegen2Request = {
                    incident_id: incidentId,
                    anlegen_request: {
                        incident_id: incidentId,
                        beschreibung: detail.beschreibung,
                        ort: detail.ort,
                        veranstaltung_id: detail.veranstaltung_id,
                        titel: detail.titel
                    }
                };
                if (detail.ist_verantwortlichkeit_abteilung || detail.ist_verantwortlichkeit_zentrale) {
                    request.verantwortlichkeit_request = {
                        incident_id: incidentId,
                        verantwortlichkeit_funktionsbereich_id: detail.verantwortlichkeit_funktionsbereich_id,
                    };
                }
                if (detail.delegation_rolle !== undefined && detail.delegation_rolle !== null) {
                    request.delegation_request = {
                        incident_id: incidentId,
                        delegation_rolle_id: detail.delegation_rolle_id,
                        delegation_funktionsbereich_id: detail.delegation_funktionsbereich_id,
                    };
                }
                // console.log('Request: ', request);
                return new PostIncidentAnlegen2Action(request);
            } else {
                // Bearbeiten
                const request: IncidentBeschreibungRequest = {
                    incident_id: incidentId,
                    beschreibung: detail.beschreibung,
                    titel: detail.titel,
                    ort: detail.ort,
                    veranstaltung_id: detail.veranstaltung_id,
                    bilder_upload_ids: detail.bilder_ids
                };
                return new PostIncidentTitelUndBeschreibungSetzenAction(request);
            }
        })
    ));

    constructor(private actions$: Actions,
                private uuid: UuidService,
                private store$: Store<any>,
                private notificationService: NotificationService) {
    }
}
